import React from 'react'
import './LogoTeam.css'
import { Input, Button, Form, Row, Col, message } from 'antd'
import config from '@/utils/config'
import { setKey } from '@/utils/Cookie'
import request from '@/utils/request'

// import Cookies from 'js-cookie' //
var myCaptcha = null
class LogoTeamForm extends React.Component {
  state = {
    codeText: '发送验证码',
    isSendCode: false, //是否能点击
    timer: null,
    count: 60,
    timer: null,
    optionData: null
  }
  componentWillUnmount(){
    console.log('销毁登录组件')
  }
  componentDidMount() {
    var that = this

    // eslint-disable-next-line
    myCaptcha = _dx.Captcha(document.getElementById('c1'), {
      style: 'popup',
      appId: 'ebaf330bfcdb7ac9b10a42b9a8e4a474', //appId，在控制台中“应用管理”或“应用配置”模块获取
      success: function(token) {
        // console.log('token:', token)
        console.log('token:')
        myCaptcha.hide()
        myCaptcha.reload()
        request
          .get(`/v1/mobile/messages/slide/code?token=${token}`)
          .then(res => {
            console.log('res1111')
            console.log(res)
            if (res == true) {
              request
                .get(`/v1/mobile/messages/login/${that.state.optionData}/code`)
                .then(res => {
                  console.log('获取验证码')
                  console.log(res)
                  message.info(res)
                  that.setState({
                    isSendCode: true
                  })
                  if (!that.state.timer) {
                    const Interval = setInterval(() => {
                      if (that.state.count > 0) {
                        that.setState({
                          codeText: `重发倒计时${that.state.count--}s`
                        })
                      } else {
                        clearInterval(that.state.timer)
                        that.setState({
                          count: 60,
                          timer: null,
                          isSendCode: false,
                          codeText: '重发验证码'
                        })
                      }
                    }, 1000)
                    that.setState({
                      timer: Interval
                    })
                  }
                })
            }
          })
      },
      fail: function(msg) {
        // console.log('token:', msg)
      }
    })
  }
  componentWillMount() {}

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // console.log('Received values of form: ', values)
        request.post('/v1/group/reserve/login', values).then(res => {
          // console.log('res')
          // console.log(res)
          if (res && res.message == '该账户正在审核中！') {
            setKey('TeamMessage', JSON.stringify(res.data))
            this.props.history.push('/Main/Team/ShowTeamAppointment')
            return
          }
          if (res && res.message == '该账户审核未通过！') {
            setKey('TeamMessage', JSON.stringify(res.status))
            this.props.history.push('/Main/Team/ShowTeamAppointment')
            return
          }
          // console.log('99999')
          setKey('SCMT-ADMIN-TOKEN', res)
          // console.log(res)
          this.props.history.push('/Main/Team/TeamAppointment')
        })
      }
    })
  }

  //正则验证手机号
  checkPhoneNub(rule, value, callback) {
    var reguPhone = /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/ //手机号码验证regEx:第一位数字必须是1，11位数字
    var rePhone = new RegExp(reguPhone)
    // console.log(rePhone.test(value))
    if (rePhone.test(value)) {
      callback()
    } else {
      callback('请输入正确的手机号！')
    }
  }
  //获取短信验证码
  GetCode = () => {
    // console.log('验证码')
    // console.log(this.props.form.getFieldValue('loginPhone'))

    let loginName = this.props.form.getFieldValue('loginPhone')
    if (!loginName || !config.regExp.phone.test(loginName)) {
      message.info('请输入正确的手机号码')
      return
    }
    this.setState({
      optionData: loginName
    })
    myCaptcha.show()
  }
  //注册
  registered = () => {
    this.props.history.push('/Main/Team/RegisteredTeam')
  }
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      }
    }
    const formItemLayout1 = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    const { codeText, isSendCode } = this.state
    return (
      <div className="LogoTeam">
        <div className="LogoTeam_AddConten">
          <Form onSubmit={this.handleSubmit}>
            <Row>
              <Form.Item label="手机号：" {...formItemLayout1}>
                {getFieldDecorator('loginPhone', {
                  rules: [
                    { required: true, message: '手机号不能为空！' },
                    { validator: this.checkPhoneNub }
                  ]
                })(
                  <Input placeholder="请输入手机号" style={{ width: '100%' }} />
                )}
              </Form.Item>
            </Row>
            <Row>
              <Col span={14}>
                <Form.Item label="短信验证：" {...formItemLayout}>
                  {getFieldDecorator('code', {
                    rules: [{ required: true, message: '请输入短信验证码' }]
                  })(<Input placeholder="请输入短信验证码" />)}
                </Form.Item>
              </Col>
              <Col span={10}>
                <div style={{ 'textAlign': 'left' }}>
                  <Button
                    type="primary"
                    disabled={isSendCode}
                    className="CodeButton"
                    onClick={el => this.GetCode()}
                  >
                    {codeText}
                  </Button>
                </div>
              </Col>
            </Row>

            <Row gutter={[20, 25]}>
              <Col span={14}>
                <div
                  style={{
                    display: 'flex',
                    'justifyContent': 'center',
                    'alignItems': 'center'
                  }}
                >
                  <Button className="LogoTeam_footer_button" htmlType="submit">
                    登录
                  </Button>
                </div>
              </Col>
              <Col span={10}>
                <div
                  style={{
                    display: 'flex',
                    'justifyContent': 'center',
                    'alignItems': 'center'
                  }}
                >
                  <div
                    className="LogoTeam_footer_reg"
                    onClick={el => this.registered()}
                  >
                    {' '}
                    企事业单位注册
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="ccc">
          <div id="c1" ref="myInput"></div>
        </div>
      </div>
    )
  }
}
const LogoTeam = Form.create()(LogoTeamForm)
export default LogoTeam
